module.exports = __webpack_public_path__ + "img/miniMap.f47e943f.jpg";